import { HappinessItem } from 'src/models/happiness-item.model';

const HAPPINESS_ICON_KEYWORDS: { test: RegExp; icon: string }[] = [
  { test: /\b(early check[- ]?in|late check[- ]?out|check[- ]?in|check[- ]?out)/i, icon: 'assets/svg/clock-outline.svg' },
  { test: /\b(mid[- ]?stay|cleaning|housekeeping)/i, icon: 'assets/svg/star-outline.svg' },
  { test: /\b(birthday|anniversary|honeymoon|special occasion|celebration)/i, icon: 'assets/svg/gift-outline.svg' },
  { test: /\b(champagne|wine|prosecco|bottle)/i, icon: 'assets/svg/wine-outline.svg' },
  { test: /\b(beer|cocktail|drink|bar|happy hour)/i, icon: 'assets/svg/beer-outline.svg' },
  { test: /\b(flower|bouquet)/i, icon: 'assets/svg/flower-outline.svg' },
  { test: /\b(airport|pickup|transfer|shuttle|ride)/i, icon: 'assets/svg/airplane-outline.svg' },
  { test: /\b(grocery|stocking|shopping|fridge)/i, icon: 'assets/svg/cart-outline.svg' },
  { test: /\b(welcome basket|welcome bag|welcome gift|hamper)/i, icon: 'assets/svg/basket-outline.svg' },
  { test: /\b(baby|crib|infant|kid|child)/i, icon: 'assets/svg/happy-outline.svg' },
  { test: /\b(coffee|cafe|espresso|latte)/i, icon: 'assets/svg/cafe-outline.svg' },
  { test: /\b(snack|chocolate|cookie|treat|cake|dessert|ice cream)/i, icon: 'assets/svg/ice-cream-outline.svg' },
  { test: /\b(tour|guide|map|local|recommendation)/i, icon: 'assets/svg/map-outline.svg' },
  { test: /\b(spa|massage|wellness)/i, icon: 'assets/svg/heart-outline.svg' },
  { test: /\b(robe|towel|toiletr)/i, icon: 'assets/svg/star-outline.svg' },
];

export function getHappinessIconSrc(item: HappinessItem | null | undefined): string {
  if (!item?.name) {return 'assets/svg/gift-outline.svg';}
  for (const k of HAPPINESS_ICON_KEYWORDS) {
    if (k.test.test(item.name)) {return k.icon;}
  }
  return 'assets/svg/gift-outline.svg';
}
